"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _semanticUiReact = require("semantic-ui-react");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _debounce = require("debounce");
var _InputField = require("../../controls/InputField");
var _Loader = _interopRequireDefault(require("../../ui/Loader"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _constants = require("../../Modal/constants");
var _actions = require("./store/actions");
var _selectors = require("./store/selectors");
var _AddNewClaimAndClientButton = _interopRequireDefault(require("./components/AddNewClaimAndClientButton"));
var _Clients = _interopRequireDefault(require("./components/Clients"));
var _search = _interopRequireDefault(require("./icons/search.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var clientsMapper = R.addIndex(R.map);
var SaveToClaimModal = function SaveToClaimModal(_ref) {
  var header = _ref.header,
    _onClose = _ref.onClose,
    onSave = _ref.onSave,
    _ref$showAddNewClaimA = _ref.showAddNewClaimAndClientButton,
    showAddNewClaimAndClientButton = _ref$showAddNewClaimA === void 0 ? true : _ref$showAddNewClaimA,
    _ref$showAddNewClaimB = _ref.showAddNewClaimButton,
    showAddNewClaimButton = _ref$showAddNewClaimB === void 0 ? true : _ref$showAddNewClaimB;
  var _useTranslation = (0, _reactI18next.useTranslation)('SAVE_TO_CLAIM_MODAL'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var clients = (0, _reactRedux.useSelector)(_selectors.getClients);
  var isEmpty = (0, _reactRedux.useSelector)(_selectors.isEmptyClients);
  var isFetching = (0, _reactRedux.useSelector)(_selectors.isFetchingClients);
  var isFail = (0, _reactRedux.useSelector)(_selectors.isFetchClientsFail);
  var debouncedGetClients = (0, _react.useMemo)(function () {
    return (0, _debounce.debounce)(function (searchString) {
      return dispatch((0, _actions.clearClients)()), dispatch((0, _actions.getClients)(searchString));
    }, 300);
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    size: _constants.SIZES.MEDIUM,
    onClose: function onClose() {
      return _onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, null, header), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, {
    className: _styles.default.root
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement(_InputField.InputField, {
    className: _styles.default.searchField,
    icon: /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.searchIcon,
      dangerouslySetInnerHTML: {
        __html: _search.default
      }
    }),
    label: t('SEARCH_INPUT_LABEL'),
    value: search,
    onChange: function onChange(event) {
      return setSearch(event.target.value), debouncedGetClients(event.target.value);
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.results
  }, isEmpty && !isFetching && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message, {
    header: t('EMPTY_SEARCH_STATE')
  }), isFail && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message, {
    error: true,
    header: "Error"
  }), isFetching && /*#__PURE__*/_react.default.createElement(_Loader.default, null), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.list
  }, clientsMapper(function (_ref2, index) {
    var adults = _ref2.adults,
      child = _ref2.child,
      client = _ref2.client,
      dateStart = _ref2.dateStart,
      id = _ref2.id,
      nights = _ref2.nights,
      performer = _ref2.performer,
      title = _ref2.title;
    return /*#__PURE__*/_react.default.createElement(_Clients.default, {
      showAddNewClaimButton: showAddNewClaimButton,
      adults: adults,
      child: child,
      claimID: id,
      clientID: client.id,
      dateStart: dateStart,
      key: index,
      name: client.name,
      nights: nights,
      performer: performer,
      title: title,
      claimIndex: index,
      onSave: onSave
    });
  }, clients))), showAddNewClaimAndClientButton && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
    className: _styles.default.addNewButton
  }, /*#__PURE__*/_react.default.createElement(_AddNewClaimAndClientButton.default, {
    onClick: onSave
  })))));
};
SaveToClaimModal.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  onSave: _propTypes.default.func.isRequired,
  header: _propTypes.default.string,
  showAddNewClaimAndClientButton: _propTypes.default.bool,
  showAddNewClaimButton: _propTypes.default.bool
};
var _default = exports.default = (0, _react.memo)(SaveToClaimModal);